import { render, staticRenderFns } from "./valinsProtocol.vue?vue&type=template&id=81eed490&scoped=true&name=valinsProtocol"
var script = {}
import style0 from "./valinsProtocol.vue?vue&type=style&index=0&id=81eed490&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "81eed490",
  null
  
)

export default component.exports